import { FC, useMemo } from 'react'
import useProgress from '@/hooks/useProcess'

interface ProgressProps {
  min?: number
  max?: number
  current: number
}

const Progress: FC<ProgressProps> = ({ min, max, current }) => {
  const percent = useProgress({ min, max, current })
  return (
    <div className="w-full h-[2px] absolute bottom-0 left-0">
      <p className="m-0 h-full bg-gradient-to-tr from-[#0096FF] via-[#BC2AEF] to-[#FF2800]" style={{ width: percent }}></p>
    </div>
  )
}

interface Props {
  fullpage?: boolean
  progress: number
  classNames?: string
}

const Mask: FC<Props> = ({ fullpage, progress, classNames, children }) => {

  const _className = useMemo(() => {
    return fullpage ? 'fixed' : 'absoluted'
  }, [fullpage])

  return (
    <div className="fixed min-w-full min-h-full w-screen h-screen top-0 left-0 pointer-events-none bg-[#000] z-[9999]">
      <div className={`${_className} h-full w-full pointer-events-auto ${classNames ?? ''}`}>
        {children}
      </div>
      <Progress current={progress} />
    </div>
  )
}

export default Mask
